module.exports = __webpack_public_path__ + "static/media/ic_pf_gold.ba46dddf.svg";